export var FilterTypes;
(function (FilterTypes) {
    FilterTypes["Filter"] = "filter";
    FilterTypes["RawFilter"] = "rawFilter";
})(FilterTypes || (FilterTypes = {}));
export var FilterSetFieldNames;
(function (FilterSetFieldNames) {
    FilterSetFieldNames["Name"] = "name";
    FilterSetFieldNames["Filters"] = "filters";
    FilterSetFieldNames["RawFilter"] = "rawFilter";
    FilterSetFieldNames["Field"] = "field";
    FilterSetFieldNames["Value"] = "value";
    FilterSetFieldNames["DerivedFromProduct"] = "derivedFromProduct";
    FilterSetFieldNames["Exclude"] = "exclude";
    FilterSetFieldNames["CreatedByEmail"] = "createdByEmail";
    FilterSetFieldNames["ModifiedByEmail"] = "modifiedByEmail";
})(FilterSetFieldNames || (FilterSetFieldNames = {}));
export const filterSetInitialValues = {
    name: '',
    filters: null,
    rawFilter: '',
};
